module.exports = __webpack_public_path__ + "static/media/question-bg.b7b2a673.svg";